import { lazy } from "@loadable/component";
import { PatientTimeProps } from "./PatientTimeline.types";
import { Suspense } from "react";
import { PatientTimelineLoading } from "./PatientTimeline.loading";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";

export const PatientTimelineLoadable = lazy(() => import("./PatientTimeline"));

export const PatientTimeline = (props: PatientTimeProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<PatientTimelineLoading />}>
      <PatientTimelineLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
